import { FC, useCallback, useState } from "react"
import { State } from "src/domain/entities/state"
import { useAuth } from "../../../domain/hooks"
import { stateDeleteService } from "../../../domain/services/state/stateDeleteService"
import { getErrorMessage } from "../../../utils/helpers"
import DeleteItemDialog from "../../shared/DeleteItemDialog"

interface Props {
	state: State
	isOpen: boolean
	setIsOpen: (isOpen: boolean) => void
	onSuccess?: () => void
}

export const StateDeleteDialogController: FC<Props> = ({
	isOpen,
	setIsOpen,
	state,
	onSuccess,
}) => {
	const { token } = useAuth()
	const [isLoading, setIsLoading] = useState(false)
	const [errorMessage, setErrorMessage] = useState<string | null>(null)

	const handleStateDelete = useCallback(async () => {
		try {
			setIsLoading(true)
			await stateDeleteService({ id: state.id }, token)
			setIsOpen(false)
			onSuccess && onSuccess()
		} catch (err) {
			setErrorMessage(getErrorMessage(err))
		} finally {
			setIsLoading(false)
		}
	}, [state, setIsOpen, token, onSuccess])

	return (
		<DeleteItemDialog
			title={`Delete State: ${state.name.en}`}
			isOpen={isOpen}
			onCancel={() => {
				setIsOpen(false)
				setErrorMessage(null)
			}}
			onDelete={handleStateDelete}
			isLoading={isLoading}
			errorMessage={errorMessage}
		/>
	)
}
